import { render, staticRenderFns } from "./IncomeAddModal.vue?vue&type=template&id=1b6a0072&"
import script from "./IncomeAddModal.vue?vue&type=script&lang=js&"
export * from "./IncomeAddModal.vue?vue&type=script&lang=js&"
import style0 from "./IncomeAddModal.vue?vue&type=style&index=0&id=1b6a0072&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports